import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RegularExpressionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RegularExpressionSVG;
